export default {
  TOKEN_LOGIN: "/auth/token_login",
  USERS: "/users",
  ACCOUNT_DELETE_REQUEST: "/account/delete/request",
  ACCOUNT_DELETE_FEEDBACK: "/account/delete/feedback"
};
